/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_DietsInputs */

const en_editor_diets = /** @type {(inputs: Editor_DietsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diet`)
};

const de_editor_diets = /** @type {(inputs: Editor_DietsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ernährung`)
};

/**
* | output |
* | --- |
* | "Diet" |
*
* @param {Editor_DietsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_diets = /** @type {((inputs?: Editor_DietsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_DietsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_diets(inputs)
	return en_editor_diets(inputs)
});